/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `A` - 캐릭터 + 비주얼라이저
 * `B` - 가사 후크
 * `C` - ASMR 환경음
 */
export type ShortsRecommendedTemplateEnum =
  (typeof ShortsRecommendedTemplateEnum)[keyof typeof ShortsRecommendedTemplateEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShortsRecommendedTemplateEnum = {
  A: "A",
  B: "B",
  C: "C",
} as const;
